import React from 'react';
import Logo from '../components/common/Logo';
import Banner from '../components/common/Banner';

const HomePage = () => {
  return (
    <div className="min-h-screen w-full fade-in">
      <Banner 
        title="About FiT Engineering College"
        subtitle="Excellence in Engineering Education | Building Tomorrow's Technology Leaders"
        imageSrc="https://images.unsplash.com/photo-1562774053-701939374585?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80"
      />
      <div className="max-w-5xl mx-auto p-4 sm:p-6 md:p-10 pb-16">
        
        {/* Engineering College Overview */}
        <section className="mb-12">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div className="bg-white p-8 sm:p-12 md:p-16 rounded-2xl shadow-soft border border-border_gray flex flex-col items-center justify-center relative">
              <span className="absolute top-4 right-4 font-mono text-[10px] text-gray-400 border border-gray-200 px-2 py-1 rounded">FiT ENGINEERING COLLEGE</span>
              <Logo size="large" />
              <div className="text-center mt-4 sm:mt-6 md:mt-8">
                <p className="text-slate font-sans font-bold text-[10px] sm:text-xs tracking-[0.2em] sm:tracking-[0.3em] uppercase">Excellence in Technology Education</p>
              </div>
            </div>
            <div className="space-y-4 sm:space-y-6 mt-8 md:mt-0">
              <h2 className="text-2xl sm:text-3xl font-serif font-bold text-slate text-center md:text-left">About FiT Engineering College</h2>
              <p className="text-sm sm:text-base text-gray-500 leading-relaxed">
                FiT Engineering College is a premier educational institution dedicated to providing 
                world-class engineering and technology education. We are committed to fostering innovation, 
                research excellence, and developing skilled professionals for the global technology landscape.
              </p>
              <div className="p-4 bg-yellow-50 border border-yellow-200 rounded text-sm text-yellow-800">
                <i className="fas fa-info-circle mr-2"></i> 
                <strong>AKTU Affiliated & BTE UP Approved</strong> - Recognized for academic excellence.
              </div>
            </div>
          </div>
        </section>


        {/* Approvals & Affiliations */}
        <section className="mb-12">
          <h2 className="text-xl sm:text-2xl font-serif font-bold text-slate mb-6 sm:mb-8 text-center md:text-left">Approvals & Affiliations</h2>
          
          {/* AICTE Section */}
          <div className="mb-8">
            <div className="bg-white p-4 sm:p-6 rounded-xl border border-border_gray">
              <div className="flex items-center mb-4">
                <div className="w-12 h-12 bg-crimson rounded-full flex items-center justify-center mr-4">
                  <i className="fas fa-university text-white text-lg"></i>
                </div>
                <div>
                  <h3 className="text-lg sm:text-xl font-bold text-slate">AICTE</h3>
                  <p className="text-sm text-gray-500">All India Council for Technical Education</p>
                </div>
              </div>
              <div className="space-y-3">
                <h4 className="font-semibold text-slate mb-2">Official Documents (Last 5 Years)</h4>
                <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-3">
                  <div className="bg-surface p-3 rounded border border-gray-200 hover:shadow-sm transition">
                    <i className="fas fa-file-pdf text-crimson mr-2"></i>
                    <span className="text-sm text-gray-700">2024-25 Approval Letter</span>
                    <div className="text-xs text-gray-500 mt-1">Click to download</div>
                  </div>
                  <div className="bg-surface p-3 rounded border border-gray-200 hover:shadow-sm transition">
                    <i className="fas fa-file-pdf text-crimson mr-2"></i>
                    <span className="text-sm text-gray-700">2023-24 Approval Letter</span>
                    <div className="text-xs text-gray-500 mt-1">Click to download</div>
                  </div>
                  <div className="bg-surface p-3 rounded border border-gray-200 hover:shadow-sm transition">
                    <i className="fas fa-file-pdf text-crimson mr-2"></i>
                    <span className="text-sm text-gray-700">2022-23 Approval Letter</span>
                    <div className="text-xs text-gray-500 mt-1">Click to download</div>
                  </div>
                  <div className="bg-surface p-3 rounded border border-gray-200 hover:shadow-sm transition">
                    <i className="fas fa-file-pdf text-crimson mr-2"></i>
                    <span className="text-sm text-gray-700">2021-22 Approval Letter</span>
                    <div className="text-xs text-gray-500 mt-1">Click to download</div>
                  </div>
                  <div className="bg-surface p-3 rounded border border-gray-200 hover:shadow-sm transition">
                    <i className="fas fa-file-pdf text-crimson mr-2"></i>
                    <span className="text-sm text-gray-700">2020-21 Approval Letter</span>
                    <div className="text-xs text-gray-500 mt-1">Click to download</div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* AKTU Section */}
          <div className="mb-8">
            <div className="bg-white p-4 sm:p-6 rounded-xl border border-border_gray">
              <div className="flex items-center mb-4">
                <div className="w-12 h-12 bg-crimson rounded-full flex items-center justify-center mr-4">
                  <i className="fas fa-graduation-cap text-white text-lg"></i>
                </div>
                <div>
                  <h3 className="text-lg sm:text-xl font-bold text-slate">AKTU</h3>
                  <p className="text-sm text-gray-500">Dr. A.P.J. Abdul Kalam Technical University</p>
                </div>
              </div>
              <div className="space-y-3">
                <h4 className="font-semibold text-slate mb-2">Affiliation Documents (Last 5 Years)</h4>
                <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-3">
                  <div className="bg-surface p-3 rounded border border-gray-200 hover:shadow-sm transition">
                    <i className="fas fa-file-pdf text-crimson mr-2"></i>
                    <span className="text-sm text-gray-700">2024-25 Affiliation Letter</span>
                    <div className="text-xs text-gray-500 mt-1">Click to download</div>
                  </div>
                  <div className="bg-surface p-3 rounded border border-gray-200 hover:shadow-sm transition">
                    <i className="fas fa-file-pdf text-crimson mr-2"></i>
                    <span className="text-sm text-gray-700">2023-24 Affiliation Letter</span>
                    <div className="text-xs text-gray-500 mt-1">Click to download</div>
                  </div>
                  <div className="bg-surface p-3 rounded border border-gray-200 hover:shadow-sm transition">
                    <i className="fas fa-file-pdf text-crimson mr-2"></i>
                    <span className="text-sm text-gray-700">2022-23 Affiliation Letter</span>
                    <div className="text-xs text-gray-500 mt-1">Click to download</div>
                  </div>
                  <div className="bg-surface p-3 rounded border border-gray-200 hover:shadow-sm transition">
                    <i className="fas fa-file-pdf text-crimson mr-2"></i>
                    <span className="text-sm text-gray-700">2021-22 Affiliation Letter</span>
                    <div className="text-xs text-gray-500 mt-1">Click to download</div>
                  </div>
                  <div className="bg-surface p-3 rounded border border-gray-200 hover:shadow-sm transition">
                    <i className="fas fa-file-pdf text-crimson mr-2"></i>
                    <span className="text-sm text-gray-700">2020-21 Affiliation Letter</span>
                    <div className="text-xs text-gray-500 mt-1">Click to download</div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* BTE UP Section */}
          <div className="mb-8">
            <div className="bg-white p-4 sm:p-6 rounded-xl border border-border_gray">
              <div className="flex items-center mb-4">
                <div className="w-12 h-12 bg-crimson rounded-full flex items-center justify-center mr-4">
                  <i className="fas fa-tools text-white text-lg"></i>
                </div>
                <div>
                  <h3 className="text-lg sm:text-xl font-bold text-slate">BTE UP</h3>
                  <p className="text-sm text-gray-500">Board of Technical Education, Uttar Pradesh</p>
                </div>
              </div>
              <div className="space-y-3">
                <h4 className="font-semibold text-slate mb-2">Approval Documents (Last 5 Years)</h4>
                <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-3">
                  <div className="bg-surface p-3 rounded border border-gray-200 hover:shadow-sm transition">
                    <i className="fas fa-file-pdf text-crimson mr-2"></i>
                    <span className="text-sm text-gray-700">2024-25 Approval Letter</span>
                    <div className="text-xs text-gray-500 mt-1">Click to download</div>
                  </div>
                  <div className="bg-surface p-3 rounded border border-gray-200 hover:shadow-sm transition">
                    <i className="fas fa-file-pdf text-crimson mr-2"></i>
                    <span className="text-sm text-gray-700">2023-24 Approval Letter</span>
                    <div className="text-xs text-gray-500 mt-1">Click to download</div>
                  </div>
                  <div className="bg-surface p-3 rounded border border-gray-200 hover:shadow-sm transition">
                    <i className="fas fa-file-pdf text-crimson mr-2"></i>
                    <span className="text-sm text-gray-700">2022-23 Approval Letter</span>
                    <div className="text-xs text-gray-500 mt-1">Click to download</div>
                  </div>
                  <div className="bg-surface p-3 rounded border border-gray-200 hover:shadow-sm transition">
                    <i className="fas fa-file-pdf text-crimson mr-2"></i>
                    <span className="text-sm text-gray-700">2021-22 Approval Letter</span>
                    <div className="text-xs text-gray-500 mt-1">Click to download</div>
                  </div>
                  <div className="bg-surface p-3 rounded border border-gray-200 hover:shadow-sm transition">
                    <i className="fas fa-file-pdf text-crimson mr-2"></i>
                    <span className="text-sm text-gray-700">2020-21 Approval Letter</span>
                    <div className="text-xs text-gray-500 mt-1">Click to download</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Accreditations */}
        <section className="mb-12">
          <h2 className="text-xl sm:text-2xl font-serif font-bold text-slate mb-6 sm:mb-8 text-center md:text-left">Accreditations</h2>
          <div className="grid sm:grid-cols-2 gap-4 sm:gap-6">
            <div className="bg-white p-4 sm:p-6 md:p-8 rounded-xl border border-border_gray flex items-center gap-3 sm:gap-4">
              <div className="w-12 h-12 bg-gold rounded-full flex items-center justify-center">
                <i className="fas fa-medal text-white"></i>
              </div>
              <div>
                <h4 className="font-bold text-slate">NAAC</h4>
                <p className="text-sm text-gray-500">National Assessment and Accreditation Council</p>
              </div>
            </div>
            <div className="bg-white p-4 sm:p-6 md:p-8 rounded-xl border border-border_gray flex items-center gap-3 sm:gap-4">
              <div className="w-12 h-12 bg-gold rounded-full flex items-center justify-center">
                <i className="fas fa-award text-white"></i>
              </div>
              <div>
                <h4 className="font-bold text-slate">NBA</h4>
                <p className="text-sm text-gray-500">National Board of Accreditation</p>
              </div>
            </div>
          </div>
        </section>

      </div>
    </div>
  );
};

export default HomePage;